'use strict';

var propTypes = require('./prop-types.js');
require('@babel/runtime/helpers/defineProperty');
require('prop-types/factoryWithTypeCheckers');
require('./constants.js');

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */

var _guidPieceGenerator = function _guidPieceGenerator() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
};
/**
 * Generate a new semi-unique id.
 *
 * @function
 * @returns {string} Returns a new semi-unique id in GUID format.
 * @example
 * getId();
 * // => '982b0157-704b-d8c6-7d63-93aab6911883'
 */


var getId = function getId() {
  return [_guidPieceGenerator() + _guidPieceGenerator(), _guidPieceGenerator(), _guidPieceGenerator(), _guidPieceGenerator(), _guidPieceGenerator() + _guidPieceGenerator() + _guidPieceGenerator()].join('-');
};

getId.HELPER_ID = 'Gearz.JsUtils.getId';
getId.returnType = propTypes.stringWithDescription('Returns a new semi-unique id in GUID format.');
getId.parameterTypes = {};
getId.defaultParameters = {};

module.exports = getId;
